import { render, staticRenderFns } from "./ThongTinDDATForm.vue?vue&type=template&id=216e5b2a&scoped=true"
import script from "./ThongTinDDATForm.vue?vue&type=script&lang=js"
export * from "./ThongTinDDATForm.vue?vue&type=script&lang=js"
import style0 from "./ThongTinDDATForm.vue?vue&type=style&index=0&id=216e5b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216e5b2a",
  null
  
)

export default component.exports